/* eslint-disable react/display-name */
import { AnalyticsTrackingContext } from '@context/AnalyticsTracking'

export const withAnalyticsTracking = (Component) => (props) => {
  return (
    <AnalyticsTrackingContext.Consumer>
      {(contextProps) => <Component {...props} {...contextProps} />}
    </AnalyticsTrackingContext.Consumer>
  )
}
